// extracted by mini-css-extract-plugin
export var settings = "CookiesSettings-module--settings--8384e";
export var settingsText = "CookiesSettings-module--settingsText--06aee";